import request from "@/utils/request";

/**
 * 获取融云用户Token接口
 *
 * @description 获取融云用户Token接口
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function getRongYunToken(playload) {
  return request({
    url: "/api/v2/rongyun/getToken",
    method: "POST",
    data: playload,
    userId: true
  });
}

/**
 *  注册融云帐号
 *
 * @description  注册融云帐号
 *
 * @see lottery接口设计文档
 * @param {Object} playload - 有效载荷
 * @param {Object} config - 额外配置
 * @return {Object} Promise
 *
 * @since 2.0.0
 *
 */
export async function registerRongYunAccount(playload) {
  return request({
    url: "/api/v2/chat/registerRongYunAccount",
    method: "POST",
    data: playload,
    noEncrypt: true
  });
}
